module.exports = __webpack_public_path__ + "static/media/user-minus.3c6fcba9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/user-minus.svg
// module id = 3745
// module chunks = 7